/**
 * File Type Selector Component
 * Allows users to choose between CSV or DXF file types
 */

import styles from './FileSourceSelector.module.css'

export type FileType = 'csv' | 'dxf'

interface FileTypeSelectorProps {
  onTypeSelect: (type: FileType) => void
  onCancel?: () => void
}

export function FileTypeSelector({
  onTypeSelect,
  onCancel,
}: FileTypeSelectorProps) {
  return (
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.container} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>파일 종류 선택</h2>
          <p className={styles.description}>작업할 파일의 종류를 선택하세요</p>
        </div>

        <div className={styles.options}>
          <button className={styles.option} onClick={() => onTypeSelect('csv')}>
            <svg className={styles.icon} width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
            <h3 className={styles.optionTitle}>CSV 파일</h3>
            <p className={styles.optionDescription}>쉼표로 구분된 값(CSV) 파일로 작업합니다</p>
          </button>

          <button className={styles.option} onClick={() => onTypeSelect('dxf')}>
            <svg className={styles.icon} width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <path d="M9 15h6" />
              <path d="M12 18v-6" />
            </svg>
            <h3 className={styles.optionTitle}>DXF 파일</h3>
            <p className={styles.optionDescription}>CAD/DXF 도면 파일로 작업합니다</p>
          </button>
        </div>

        {onCancel && (
          <button onClick={onCancel} className={styles.cancelButton}>
            취소
          </button>
        )}
      </div>
    </div>
  )
}
